"use strict";

exports.__esModule = true;
exports.ErrorText = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = require("../Text");
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ErrorText = exports.ErrorText = (0, _styledComponents["default"])(_Text.Text).withConfig({
  displayName: "styles__ErrorText",
  componentId: "sc-48i1la-0"
})(["margin-top:", ";"], (0, _Theme.val)("marginLarge"));